module.exports = __webpack_public_path__ + "img/emoji_52.aee5d4a4.png";